export const INVENTORY_CHECK_ARTICLE_NEW_AMOUNT_FIELD_NAME = "newAmount";
export const INVENTORY_CHECK_ARTICLE_HAS_CHANGED_FIELD_NAME = "hasChanged";
export const INVENTORY_CHECK_ARTICLE_DESCRIPTION_FIELD_NAME = "description";
